"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a, _b, _c, _d, _e;

var react_1 = __importStar(require("react")); // import posed, { PoseGroup } from 'react-pose'


var WillEnter_1 = __importStar(require("../WillEnter"));

var AnimationFactory = function AnimationFactory(options) {
  var Pose =
  /** @class */
  function (_super) {
    __extends(Pose, _super);

    function Pose() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.currentStyle = function () {
        var status = _this.state.status;
        return options[status] || {};
      };

      return _this;
    }

    Pose.prototype.render = function () {
      return react_1.default.createElement("div", {
        style: __assign({}, options.default, this.currentStyle())
      }, this.props.children);
    };

    return Pose;
  }(WillEnter_1.default);

  return (
    /** @class */
    function (_super) {
      __extends(Animation, _super);

      function Animation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;

        _this.state = {
          active: false
        };
        return _this;
      }

      Animation.prototype.componentDidMount = function () {
        var _this = this;

        this.timerId = setTimeout(function () {
          _this.setState({
            active: true
          });
        }, this.props.timer || 100);
      };

      Animation.prototype.componentWillUnmount = function () {
        clearTimeout(this.timerId);
      };

      Animation.prototype.render = function () {
        var active = typeof this.props.active === 'boolean' ? this.props.active : this.state.active;
        return react_1.default.createElement(Pose, {
          active: active
        }, this.props.children);
      };

      return Animation;
    }(react_1.Component)
  );
}; // const Fade = (options: any) => {
//   const Pose = posed.div(options)
//   return class extends Component<AnimationProps> {
//     state = { active: false }
//     timerId: any
//     componentDidMount() {
//       this.timerId = setTimeout(() => {
//         this.setState({ active: true })
//       }, this.props.timer || 100)
//     }
//     componentWillUnmount() {
//       clearTimeout(this.timerId)
//     }
//     render() {
//       const active =
//         typeof this.props.active === 'boolean'
//           ? this.props.active
//           : this.state.active
//       return (
//         <PoseGroup>
//           {active && (
//             <Pose key={this.props.id || 'child'} {...this.props}>
//               {this.props.children}
//             </Pose>
//           )}
//         </PoseGroup>
//       )
//     }
//   }
// }


exports.FadeIn = AnimationFactory((_a = {
  default: {
    transition: 'opacity 0.3s ease-in'
  }
}, _a[WillEnter_1.Status.ENTERING] = {
  opacity: 1
}, _a[WillEnter_1.Status.ENTERED] = {
  opacity: 1
}, _a[WillEnter_1.Status.EXITING] = {
  opacity: 0
}, _a[WillEnter_1.Status.EXITED] = {
  opacity: 0
}, _a));
exports.SlideInRight = AnimationFactory((_b = {
  default: {
    transition: 'opacity 0.3s ease-in, transform 0.3s ease-in'
  }
}, _b[WillEnter_1.Status.ENTERING] = {
  transform: 'translateX(0%)',
  opacity: 1
}, _b[WillEnter_1.Status.ENTERED] = {
  transform: 'translateX(0%)',
  opacity: 1
}, _b[WillEnter_1.Status.EXITING] = {
  transform: 'translateX(-100%)',
  opacity: 0
}, _b[WillEnter_1.Status.EXITED] = {
  transform: 'translateX(-100%)',
  opacity: 0
}, _b));
exports.SlideInLeft = AnimationFactory((_c = {
  default: {
    transition: 'opacity 0.3s ease-in, transform 0.3s ease-in'
  }
}, _c[WillEnter_1.Status.ENTERING] = {
  transform: 'translateX(0%)',
  opacity: 1
}, _c[WillEnter_1.Status.ENTERED] = {
  transform: 'translateX(0%)',
  opacity: 1
}, _c[WillEnter_1.Status.EXITING] = {
  transform: 'translateX(100%)',
  opacity: 0
}, _c[WillEnter_1.Status.EXITED] = {
  transform: 'translateX(100%)',
  opacity: 0
}, _c));
exports.SlideInUp = AnimationFactory((_d = {
  default: {
    transition: 'opacity 0.3s ease-in, transform 0.3s ease-in'
  }
}, _d[WillEnter_1.Status.ENTERING] = {
  transform: 'translateY(0%)',
  opacity: 1
}, _d[WillEnter_1.Status.ENTERED] = {
  transform: 'translateY(0%)',
  opacity: 1
}, _d[WillEnter_1.Status.EXITING] = {
  transform: 'translateY(100%)',
  opacity: 0
}, _d[WillEnter_1.Status.EXITED] = {
  transform: 'translateY(100%)',
  opacity: 0
}, _d));
exports.SlideInDown = AnimationFactory((_e = {
  default: {
    transition: 'opacity 0.3s ease-in, transform 0.3s ease-in'
  }
}, _e[WillEnter_1.Status.ENTERING] = {
  transform: 'translateY(0%)',
  opacity: 1
}, _e[WillEnter_1.Status.ENTERED] = {
  transform: 'translateY(0%)',
  opacity: 1
}, _e[WillEnter_1.Status.EXITING] = {
  transform: 'translateY(-100%)',
  opacity: 0
}, _e[WillEnter_1.Status.EXITED] = {
  transform: 'translateY(-100%)',
  opacity: 0
}, _e));